import { FlexBox, Text } from '@fable/components'
import { css } from '@fable/theme'
import { useGoalHabits } from '../../lib/ctx'
import { useStatsTheme } from 'app/webview/pages/stats_profile/theme/ctx'

export const ChartXAxis = () => {
  const theme = useStatsTheme((s) => s.theme)
  const data = useGoalHabits((s) => s.weekData)

  return (
    <div
      className={css`
        padding-right: 25px;
        width: 100%;
        display: grid;
        grid-template-columns: repeat(10, 1fr);
        gap: 8px;
      `}
    >
      {data.map((item, i) => (
        <FlexBox
          key={i}
          className={css`
            padding-top: 5px;
            width: 100%;
            position: relative;
          `}
          flexDirection="column"
          alignItems="center"
        >
          <span
            className={css`
              display: block;
              width: 1px;
              height: 2px;
              background-color: ${theme.colors.section.textSecondary};
            `}
          />
          <Text
            type="body"
            className={css`
              font-size: 8px;
              line-height: 8px;
              position: absolute;
              top: 11px;
              left: 50%;
              transform: translateX(-50%);
              white-space: nowrap;
            `}
            weight="500"
            color={theme.colors.section.textSecondary}
            align="center"
          >
            {i % 2 ? '' : item.date}
          </Text>
        </FlexBox>
      ))}
    </div>
  )
}
